import common from "../common";
import AjaxService_ from "../services/AjaxService";
import core from "../core";
import moment_ from "moment";
import utilities_ from "../modules/utilities";

declare function require(module: string): unknown;
const moment = require("moment") as typeof moment_;
const utilities = require("../modules/utilities") as typeof utilities_;
//onst AjaxService = require("../services/AjaxService") as AjaxService_;

interface IPoolerConfig {
    frequencySec?: number | null;
    poolingUrl: string;
}

interface IPoolableItem {
    item: common.IPoolable;
}

class Pooler {

    private readonly _defaultFrequencySec = 30;
    private readonly _ajaxService: AjaxService_;
    private readonly _config: IPoolerConfig;
    private _isRunning = false;
    private _latestTimeout = null as any;
    private _poolingDate = null as Date | null;
    private _lastPoolingDate = null as Date | null;
    private _iteration = -1;
    private _registry = [] as IPoolableItem[];

    constructor(config: IPoolerConfig) {
        if (!config)
            throw "L'argument 'config' est requis.";

        if (!config.poolingUrl)
            throw "L'argument 'config.poolingUrl' est requis.";

        this._config = config;

        if (!this._config.frequencySec)
            this._config.frequencySec = this._defaultFrequencySec;

        this._ajaxService = new AjaxService_();
    }

    start() {
        if (this._isRunning)
            return this;

        this._isRunning = true;

        this.pool();

        return this;
    }

    stop() {
        if (!this._isRunning)
            return this;

        this._isRunning = false;

        if (this._latestTimeout)
            clearTimeout(this._latestTimeout);

        return this;
    }

    restart() {
        this.stop();
        this.start();
        return this;
    }

    registerPoolable(obj: common.IPoolable) {
        if (!obj)
            throw "L'argument 'inst' est requis, mais est NULL.";

        this._registry.push({
            item: obj,
            lastPoolingDate: null
        } as IPoolableItem);

        return this;
    }

    unregisterPoolable(obj: common.IPoolable) {
        if (!obj)
            throw "L'argument 'inst' est requis, mais est NULL.";

        const index = this._registry.findIndex(x => x.item === obj);
        if (index >= 0)
            this._registry.splice(index, 1);

        return this;
    }

    private toUtcString(date: Date | null) {
        if (!date)
            return null;

        const m = moment(date);

        m.add(-1 * m.utcOffset(), 'minutes');

        return m.utc().toISOString();
    }

    private getPoolingInformations() {

        return {
            frequencySec: this._config.frequencySec,
            iteration: this._iteration,
            poolingDate: this._poolingDate,
            poolingDateUtcString: this.toUtcString(this._poolingDate),
            lastPoolingDate: this._lastPoolingDate || null,
            lastPoolingDateUtcString: this.toUtcString(this._lastPoolingDate)
        } as common.IPoolerInformations;
    }

    /** Retournera l'objet d'arguments SEULEMENT si la requette doit etre envoyé. */
    private buildPostArguments() {
        var mustSend = false;

        const info = this.getPoolingInformations();

        //const data = new FormData();
        // data.append("iteration", info.iteration.toString());
        // data.append("poolingDate", info.poolingDateUtcString);
        // data.append("lastPoolingDate", info.lastPoolingDateUtcString);
        // data.append("currentUrl", utilities.currentUrl());
        // data.append("messagesManagerFetchArgs", null);
        // data.append("searchBoxFetchArgs", null);

        const data = {
            iteration: info.iteration,
            poolingDate: info.poolingDateUtcString,
            lastPoolingDate: info.lastPoolingDateUtcString,
            currentUrl: utilities.currentUrl(),
            messagesManagerFetchArgs: null,
            searchBoxFetchArgs: []
        } as common.IPoolerFetchArguments;

        this._registry.forEach(x => {
            const go = x.item.onPooling(data, info);
            if (!mustSend && go)
                mustSend = true;
        });

        return mustSend ? data : null;
    }
    private _isWaiting = false;
    private pool() {

        const repoolAfterDelay = () => {
            const d = (this._config.frequencySec ?? 1) * 1000;
            this._latestTimeout = setTimeout(() => {
                this.pool();
            }, d);
        };

        if (this._isWaiting) {
            console.warn("[UpaSti/Pooler] Une tentative de pool a été effectuée alors qu'une requette précédente n'a pas encore reçu de réponse. Cette tentative a été ignorée.");
            return;
        }

        this._iteration++;

        const postArgs = this.buildPostArguments();
        if (postArgs) {
            this._ajaxService.post(this._config.poolingUrl, postArgs, true, (responseData: common.IPoolingFetchResponseData) => {

                const errors = [];

                // Validation de la reponse
                if (!responseData)
                    errors.push(new core.Error("Les données retournées par le système de mise à jour (ApiPooling) sont NULL."));

                // Application des callbacks
                if (errors.length)
                    this.onPoolingError(errors);
                else
                    this.onPoolingSuccess(responseData);

                // Relancer le pooler
                repoolAfterDelay();
            }, (errors: any, config: any) => {

                this.onPoolingError(errors, true);

                //NOTE: en cas d'erreur 140 (unauthorized) on stop le pooler.
                if (errors && errors.length > 0 && errors[0].code === 140)
                    stop();
                else repoolAfterDelay();
            }, () => {
                this._isWaiting = true;
            }, () => {
                this._isWaiting = false;
            });
        } else repoolAfterDelay();
    }

    private onPoolingSuccess(data: common.IPoolingFetchResponseData) {
        this._registry.forEach(x => {
            if (x.item.onPoolingSuccess)
                x.item.onPoolingSuccess(data);
        });
    }

    private onPoolingError(errors: common.IError[], isHttpError?: boolean) {
        isHttpError = isHttpError === true;

        if (isHttpError) {
            var m = '';
            (errors || []).forEach(x => {
                if (m) m += ' ||| ';
                m += x.message;
                if (x.code)
                    m += " (" + x.code + ").";
            });
            m = '[UpaSti/Pooler] Une ou plusieurs erreurs sont survues : ' + m;
            utilities.printError(m);
            return;
        }

        this._registry.forEach(x => {
            if (x.item.onPoolingError)
                x.item.onPoolingError(errors);
        });
    }
}

export = Pooler;